<template>
  <div class="labelDialog">
    <el-dialog
      @close="OnClose"
      :title="title"
      :visible.sync="visible"
      width="60%"
    >
      <div class="labelBox">
        <div class="labelList clearfix" v-if="labelList.length">
          <div class="labelItem" v-for="(item,index) in labelList" :key="index">{{item}}</div>
        </div>
        <div v-if="noData" class="noLabel">该用户暂时没用标签</div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="OnClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getUserTags } from 'api/request'
export default {
  props: {
    showLabel: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    desObj: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data() {
    return {
      visible: this.showLabel,
      title:this.desObj.name+'用户的标签信息',
      labelList:[],
      noData:false
    }
  },
  watch:{
    showLabel:{
      immdediate:true,
      handler(showLabel){
        this.visible = this.showLabel
      }
    }
  },
  methods:{
    OnClose() {
      this.$emit('update:showLabel', false)
    },
    async getLableDes() {
      let params = {
        userId: this.desObj.id
      }
      let data = await getUserTags(params)
      if(data.length){
        this.labelList = data
        this.noData = false
      }else{
        this.noData = true
      }
      
    }
  },
  created() {
    this.getLableDes()
  }
}
</script>
<style lang='scss' scoped>
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.labelItem{
  float: left;
  padding: 0 10px;
  font-size: 12px;
  margin-right: 10px;
  margin-bottom: 10px;
  line-height: 30px;
  background-color: #049ea3;
  text-align: center;
  color: #fff;
  border-radius: 3px;
}
.noLabel{
  font-size: 16px;
  text-align: center;
}
</style>